/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getHospitalInstitutions } from 'app/entities/hospital-institution/hospital-institution.reducer';
import { PackageType } from 'app/shared/model/enumerations/package-type.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { DiscPref } from 'app/shared/model/enumerations/disc-pref.model';
import { createEntity, getEntity, reset, updateEntity } from './payment-scheme.reducer';

export const PaymentSchemeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const hospitalInstitutions = useAppSelector(state => state.hospitalInstitution.entities);
  const paymentSchemeEntity = useAppSelector(state => state.paymentScheme.entity);
  const loading = useAppSelector(state => state.paymentScheme.loading);
  const updating = useAppSelector(state => state.paymentScheme.updating);
  const updateSuccess = useAppSelector(state => state.paymentScheme.updateSuccess);
  const packageTypeValues = Object.keys(PackageType);
  const patientTypeValues = Object.keys(PatientType);
  const discPrefValues = Object.keys(DiscPref);

  const handleClose = () => {
    navigate(`/payment-scheme${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getHospitalInstitutions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.maxDiscountPercentage !== undefined && typeof values.maxDiscountPercentage !== 'number') {
      values.maxDiscountPercentage = Number(values.maxDiscountPercentage);
    }
    if (values.suspendedDate !== undefined && typeof values.suspendedDate !== 'number') {
      values.suspendedDate = Number(values.suspendedDate);
    }
    if (values.gracePeriod !== undefined && typeof values.gracePeriod !== 'number') {
      values.gracePeriod = Number(values.gracePeriod);
    }
    if (values.remindBefore !== undefined && typeof values.remindBefore !== 'number') {
      values.remindBefore = Number(values.remindBefore);
    }
    if (values.proposedValue !== undefined && typeof values.proposedValue !== 'number') {
      values.proposedValue = Number(values.proposedValue);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.pharmacyDiscPercent !== undefined && typeof values.pharmacyDiscPercent !== 'number') {
      values.pharmacyDiscPercent = Number(values.pharmacyDiscPercent);
    }
    if (values.maxDiscountAmount !== undefined && typeof values.maxDiscountAmount !== 'number') {
      values.maxDiscountAmount = Number(values.maxDiscountAmount);
    }
    if (values.maxCapAmount !== undefined && typeof values.maxCapAmount !== 'number') {
      values.maxCapAmount = Number(values.maxCapAmount);
    }
    if (values.labDiscPercent !== undefined && typeof values.labDiscPercent !== 'number') {
      values.labDiscPercent = Number(values.labDiscPercent);
    }
    if (values.consDiscPercent !== undefined && typeof values.consDiscPercent !== 'number') {
      values.consDiscPercent = Number(values.consDiscPercent);
    }
    if (values.procedureDiscPercent !== undefined && typeof values.procedureDiscPercent !== 'number') {
      values.procedureDiscPercent = Number(values.procedureDiscPercent);
    }
    if (values.ipDiscPercent !== undefined && typeof values.ipDiscPercent !== 'number') {
      values.ipDiscPercent = Number(values.ipDiscPercent);
    }

    const entity = {
      ...paymentSchemeEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      institution: hospitalInstitutions.find(it => it.id.toString() === values.institution?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          packageType: 'OPEN',
          serviceType: 'OP',
          discPreference: 'MIN',
          ...paymentSchemeEntity,
          hospital: paymentSchemeEntity?.hospital?.id,
          institution: paymentSchemeEntity?.institution?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paymentScheme.home.createOrEditLabel" data-cy="PaymentSchemeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paymentScheme.home.createOrEditLabel">Create or edit a PaymentScheme</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="payment-scheme-id"
                  label={translate('tinyMedicRestApp.paymentScheme.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.name')}
                id="payment-scheme-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.startDate')}
                id="payment-scheme-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.endDate')}
                id="payment-scheme-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.addedBy')}
                id="payment-scheme-addedBy"
                name="addedBy"
                data-cy="addedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.maxDiscountPercentage')}
                id="payment-scheme-maxDiscountPercentage"
                name="maxDiscountPercentage"
                data-cy="maxDiscountPercentage"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.suspended')}
                id="payment-scheme-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.suspendedReason')}
                id="payment-scheme-suspendedReason"
                name="suspendedReason"
                data-cy="suspendedReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.suspendedDate')}
                id="payment-scheme-suspendedDate"
                name="suspendedDate"
                data-cy="suspendedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.suspendedBy')}
                id="payment-scheme-suspendedBy"
                name="suspendedBy"
                data-cy="suspendedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.packageType')}
                id="payment-scheme-packageType"
                name="packageType"
                data-cy="packageType"
                type="select"
              >
                {packageTypeValues.map(packageType => (
                  <option value={packageType} key={packageType}>
                    {translate(`tinyMedicRestApp.PackageType.${packageType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.serviceType')}
                id="payment-scheme-serviceType"
                name="serviceType"
                data-cy="serviceType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.gracePeriod')}
                id="payment-scheme-gracePeriod"
                name="gracePeriod"
                data-cy="gracePeriod"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.remindBefore')}
                id="payment-scheme-remindBefore"
                name="remindBefore"
                data-cy="remindBefore"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.proposedValue')}
                id="payment-scheme-proposedValue"
                name="proposedValue"
                data-cy="proposedValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.active')}
                id="payment-scheme-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.cursor')}
                id="payment-scheme-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.lastUpdated')}
                id="payment-scheme-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.microSec')}
                id="payment-scheme-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.timestampEntry')}
                id="payment-scheme-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.pharmacyDiscPercent')}
                id="payment-scheme-pharmacyDiscPercent"
                name="pharmacyDiscPercent"
                data-cy="pharmacyDiscPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.maxDiscountAmount')}
                id="payment-scheme-maxDiscountAmount"
                name="maxDiscountAmount"
                data-cy="maxDiscountAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.maxCapAmount')}
                id="payment-scheme-maxCapAmount"
                name="maxCapAmount"
                data-cy="maxCapAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.discPreference')}
                id="payment-scheme-discPreference"
                name="discPreference"
                data-cy="discPreference"
                type="select"
              >
                {discPrefValues.map(discPref => (
                  <option value={discPref} key={discPref}>
                    {translate(`tinyMedicRestApp.DiscPref.${discPref}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.enforceCap')}
                id="payment-scheme-enforceCap"
                name="enforceCap"
                data-cy="enforceCap"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.extendedTarrifs')}
                id="payment-scheme-extendedTarrifs"
                name="extendedTarrifs"
                data-cy="extendedTarrifs"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.labDiscPercent')}
                id="payment-scheme-labDiscPercent"
                name="labDiscPercent"
                data-cy="labDiscPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.consDiscPercent')}
                id="payment-scheme-consDiscPercent"
                name="consDiscPercent"
                data-cy="consDiscPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.procedureDiscPercent')}
                id="payment-scheme-procedureDiscPercent"
                name="procedureDiscPercent"
                data-cy="procedureDiscPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentScheme.ipDiscPercent')}
                id="payment-scheme-ipDiscPercent"
                name="ipDiscPercent"
                data-cy="ipDiscPercent"
                type="text"
              />
              <ValidatedField
                id="payment-scheme-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.paymentScheme.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="payment-scheme-institution"
                name="institution"
                data-cy="institution"
                label={translate('tinyMedicRestApp.paymentScheme.institution')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalInstitutions
                  ? hospitalInstitutions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/payment-scheme" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PaymentSchemeUpdate;
